import React from 'react';
import { connect } from "react-redux";
import $ from "jquery";
import {hashHistory} from "react-router";

import {LayoutAbbreviations} from "../kvComponent/core/constants";
import {LayoutType} from "../bvComponent/core/constants";
import {AVAILABLE_VISUALIZERS} from "../../config";
import {
  setInitialFlowFinished,
  setInitialFlowRoom,
  setInitialFlowRoomLayout,
  setInitialFlowStep, setInitialFlowType
} from "../../actions/initialFlowFunctions";
import {toggleBathroomVisualizerOpen} from "../../actions/actionFunctions";
import {INITIAL_FLOW_BUTTON_TYPES} from "../../reducers/initialFlowReducer";
import goToMaterialPage from "../common/goToMaterialPage";
import NavigationRequests from "../visComponents/navigation/navigationRequests";

class InitialFlowLayout extends NavigationRequests {

  componentDidMount() {
    this.props.setInitialFlowStep(2);
    this.props.toggleBathroomVisualizerOpen(false);
    this.setMissingInititalFlowValues();
    $(".flow, .flow-layouts, .flow-footer").fadeIn(300);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.visualizersLoaded.length && !this.props.visualizersLoaded.length) {
      this.exitInitialFlow();
    }
  }

  setMissingInititalFlowValues = () => {
    if (!this.props.initialFlowType) {
      this.props.setInitialFlowType(INITIAL_FLOW_BUTTON_TYPES.Quote)
    }
    if (!this.props.initialFlowRoom) {
      let room = AVAILABLE_VISUALIZERS.Kitchen;
      switch (document.kvConfig.visualizerType) {
        case AVAILABLE_VISUALIZERS.Bathroom:
          room = AVAILABLE_VISUALIZERS.Bathroom;
          break;
        case AVAILABLE_VISUALIZERS.Kitchen:
        default:
          break;
      }
      this.props.setInitialFlowRoom(room);
    }
  };

  exitInitialFlow = () => {
    switch (this.props.initialFlowType) {
      case INITIAL_FLOW_BUTTON_TYPES.Design: {
        this.props.toggleBathroomVisualizerOpen(true);
        hashHistory.push('visualizer');
        break;
      }
      case INITIAL_FLOW_BUTTON_TYPES.Quote: {
        goToMaterialPage("quote-design");
        break;
      }
      default:
        hashHistory.push('quote-design');
        break;
    }
  };

  handleInitialRoomLayoutClick = (layoutIndex) => {
    this.props.setInitialFlowRoomLayout(layoutIndex);
    this.props.setInitialFlowStep(3);
    this.props.setInitialFlowFinished(true); // is set only once to true (to load visualizer)
    $(".flow").fadeOut(300, () => {
      if (this.props.initialFlowFinished && this.props.visualizersLoaded.length) {
        this.changeLayout(layoutIndex);
        this.exitInitialFlow();
      }
    });
  };

  getLayouts = () => {
    switch (this.props.initialFlowRoom) {
      case AVAILABLE_VISUALIZERS.Bathroom:
        return Object.keys(LayoutType);
      case AVAILABLE_VISUALIZERS.Kitchen:
        return LayoutAbbreviations;
      default:
        return []
    }
  };

  render() {
    return (
      <div className="flow-layouts">
        {this.getLayouts().map((layoutName, layoutIndex) => (
          <button className={"flow-buttons__button flow-buttons__button--layout flow-buttons__button--" + layoutName
          + (layoutIndex === this.props.initialFlowRoomLayout ? " flow-buttons__button--selected" : "")}
                  key={layoutName}
                  onClick={() => this.handleInitialRoomLayoutClick(layoutIndex)}>
          </button>
        ))}
      </div>
    )
  }
}

const mapStateToProps = (store) => {
  return {
    initialFlowRoomLayout: store.initialFlowState.initialFlowRoomLayout,
    initialFlowRoom: store.initialFlowState.initialFlowRoom,
    initialFlowType: store.initialFlowState.initialFlowType,
    initialFlowFinished: store.initialFlowState.initialFlowFinished,
    visualizersLoaded: store.serverState.visualizersLoaded,
  };
};

export default connect(mapStateToProps, {
  setInitialFlowRoomLayout,
  setInitialFlowStep,
  setInitialFlowFinished,
  toggleBathroomVisualizerOpen,
  setInitialFlowRoom,
  setInitialFlowType
})(InitialFlowLayout);
